module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("CHAPTER 1")])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RAGMATIC AND PRACTICAL")]), _vm._v(", Chloe Cooper didn’t believe in letting fate have its way. Nope, in her opinion, people made their own destiny, thank you very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That knowledge was the driving force behind her entire life, including putting herself through college and running her own accounting firm. Things were good for her, because she’d made them so through sheer will.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sure, there was the occasional hiccup, like right now, for example. She sat outside, at a table surrounded by the evening’s jovial festivities. The Fairfax building complex was holding a Valentine’s Day celebration. The southern California evening was February mild, warm and lovely. Perfect for the commercialized holiday, if one went for that sort of thing—which Chloe didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She also didn’t go for palm readers—which explained her discomfort in finding her hand presently being held by Isabelle Girard, a fortune-teller hired to entertain the party goers with their individual fortunes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Uh-huh. Being her own boss had benefits. It meant she could leave whenever she wanted, which she’d just done. Upon coming out of her office and down into the courtyard, Chloe had tried to sneak past the table, so she could instead head directly for what she’d come outside for in the first place—refreshments. But apparently The Legendary Madame Karma, as she called herself, had eyes in the back of her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sit,” she’d commanded, pointing a long, bony finger at the chair in front of her table.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Chloe had never done well with confrontation, so she’d sat. One thing about the faux winters here in L.A., she got away with light skirts and sweaters at work. No gloves required, not when the air hovered near seventy-five degrees.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame Karma took Chloe’s hand, while Chloe squirmed. She’d chewed her thumbnail to the quick, she hadn’t painted her nails and she’d forgotten to put lotion on her dry skin this morning. She also had several paper cuts, the hazard of her job as an accountant. Not exactly a pampered hand, or a pretty one, and she resisted the urge to shove it beneath the table so it wouldn’t have to bear any closer scrutiny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pay attention,” Madame Karma admonished.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Right. Pay close attention because this was so important. "), _c('i', [_vm._v("Much")]), _vm._v(" more important than, say, heading directly to the coffee shop where she’d planned to buy her goodies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame Karma dipped her head over Chloe’s palm, studying it intensely. “Hmm,” she said ominously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chloe resisted the urge to roll her eyes. Instead she pressed her tongue firmly against her cheek because here it came, the doom and gloom. “I know. I have a short lifeline, right? Or wait, let me guess. I’m going to have three kids someday?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” Madame Karma said. “And yes.” She lifted her head, her startlingly red hair blowing around her head in the light evening breeze. From far away came a flash of lightning, a weak one, but Chloe still jumped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Creepy.")]), _vm._v(" “Well, that clears that up, thanks.” Chloe started to stand but Madame Karma didn’t let go of her hand. “Uh…my hand?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With a fierce frown, the older woman tugged on said appendage until Chloe reluctantly sat once more. “No, you do not have a short lifeline,” Madame Karma clarified, bending again over Chloe’s palm. “And yes, you’re going to have three kids.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Chloe had been biting her tongue but a snort escaped. Madame Karma’s head snapped up, her brow knitted tight as the breeze turned into a wind. Around them there were a few squeals ")]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("of surprise from the other party goers, but the fortune-teller only had eyes for Chloe. “You don’t believe?”")])]), _c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry.” Chloe tried a smile. “I’m sure you’re very nice, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Nice has nothing to do with it. Your destiny is on a very clear path, young woman, and I suggest you take it much more seriously than you have.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chloe glanced across the spacious courtyard of the Fairfax complex. Behind the graying clouds, the sun had just gone down for the count, but instead of looking gloomy, the outdoor area was lit with sparkling festive lights. She could easily see through the coffee shop window to the display cases strewn with cookies, cakes and pies, and her stomach growled. “Okay. Yes, you’re right. I’ll take it seriously. Let’s hear it.” Because the sooner she did, the sooner she was out of there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame Karma was quiet a moment, studying Chloe in a way that might have made her feel bad if she hadn’t been on a hell-bent cookie mission. “I have a prediction for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hopefully that she had cookies in her near future. Lots of cookies. Despite Chloe’s good intentions, her eyes strayed again to Constant Cravings, the coffee shop, which undoubtedly had the best cookies Chloe had ever tasted.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“True love is going to walk into your life,” the fortune-teller said instead. “Tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chloe’s eyes snapped back to the woman, and, she couldn’t help it, she burst into laughter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame Karma’s eyes seemed to penetrate her. Again the wind whipped through the courtyard. “You find that funny?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sorry.” Chloe swallowed hard. “It’s…well, it’s just silly.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? "), _c('i', [_vm._v("Love?")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No.” Chloe shoved back the strands of hair loosened from her ponytail by the wind and shivered. Was the temperature dropping? “It’s the fact that you can tell me, with a straight face, that love is about to walk into my life. I mean, I’m just picturing love walking, that’s all, and…” She let out a small laugh.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("Madame Karma straightened her bony shoulders as the wind increased again. A few sequins fell off her colorful costume, drifting through the swirling air around her. “Are you doubting my talents, or mocking your own ability to find love?” she asked, not unkindly.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Um…both? Chloe was nothing if not sensible, and maybe occasionally hard-headed. Okay, a lot hard-headed. But having her feet firmly on the ground at all times guaranteed a bit of both at times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The thing was, she didn’t believe in love at first sight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh, in theory, it was a nice concept. And she’d certainly gone after that concept in her youth. Hadn’t she kissed a bunch of frogs, just waiting for her prince?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only he’d never actually appeared.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Or maybe it was that he’d never stuck around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not that she needed to share "), _c('i', [_vm._v("that")]), _vm._v(" with Madame Karma, who sat there staring at Chloe as though she were a specimen under a microscope. “Your true love "), _c('i', [_vm._v("is")]), _vm._v(" about to walk into your life,” the woman insisted. “You can’t change your destiny by being in denial.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You seriously expect me to believe that some guy is going to walk into this party, seek me out and be the love of my life?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t say anything about seeking you out,” Madame Karma replied. “I’ve been doing this for six decades now. I say only what I absolutely mean, and I mean what I say. In fact, you’ll seek him out.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chloe laughed again, but Madame Karma didn’t even produce a smile. The woman could have no idea how amusing that was. Chloe liked to see things in their place, all nicely totaled and balanced. It was what made accounting such a perfect profession—the numbers always obeyed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Love, on the other hand, wasn’t nice and neat, and it certainly didn’t balance worth a damn. She knew that firsthand. She would never willingly seek out love. “I’m sorry. It just all sounds utterly ridiculous to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Fine.” Madame Karma leaned forward over the table. “But that is your fate—whether you think it’s ridiculous or not.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("“I didn’t mean to insult you—”")])]), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, you didn’t. But I’d watch your back if I were you.” Madame’s eyes were dark and serious, made all the more intimidating by the way the wind continued to whip her hair around her head, with more sequins flying off to parts unknown. “Because, Chloe Cooper, your karma is heading south for the winter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What? You don’t seriously believe—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, I do,” Madame Karma said with a grim smile. “It’s what happens when people laugh at their fortune. Their karma takes a vacation to the Bahamas. Your love life? Consider it "), _c('i', [_vm._v("cursed.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oka-a-a-ay.” Chloe didn’t believe in cursed love lives any more than she did in karma taking vacations. If she wanted a lover, she could get one, thank you very much.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Probably.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Maybe.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Okay, who knew for sure? But that was beside the point. So she’d been a little busy, and maybe she’d ignored certain aspects of her world. "), _c('i', [_vm._v("Like her love life.")]), _vm._v(" But since graduating college six years ago, she’d been working her tail off, building up her bookkeeping business, spending long days and nights with numbers as her closest company, because security and stability were extremely important to her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She would not apologize for that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So she didn’t have a valentine this year. She refused to associate that with her so-called cursed love life. She’d simply forgotten to put a man on her to-do list.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Had she had a valentine last year?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sad to say, she couldn’t even remember. Jeez, that couldn’t be a good sign, and for a second, for a blink really, she almost wished she believed in all this destiny talk, because bumping into the love of her life right now might be nice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Madame Karma stood to her barely five foot height, signaling that their little meeting was over. That’s when Chloe saw the small discreet jar with a sign indicating the fee for a “reading.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_115"
    }
  }), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('i', [_vm._v("She just threatened me with bad karma and now I have the privilege of paying her for it,")]), _vm._v(" she thought.")])]), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Since you don’t believe in what I do,” Madame Karma said, “what I said can’t possibly be a threat.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chloe blinked. She’d swear the woman had just read her mind—if she believed in that hooey. “Fine,” she said and slapped her pockets for the bills she’d put in there—her cookie money, damn it—then stuffed them in the jar. Not messing around, she pushed away from the table, her gaze shifting to Constant Cravings.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She "), _c('i', [_vm._v("really")]), _vm._v(" needed some sugar. Near the coffee shop was the huge fountain marking the center of the courtyard. It shot streams of water into the air, spritzing the myriad colorful flowers lining the walkways. The wrought-iron benches were filled with people, some nibbling on food, some going after their valentine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She stalked directly to the coffee shop. The owner and Chloe were friends, and as soon as she entered, Lacey smiled and greeted her. Knowing she could buy on account if she had to—which she now did have to, thanks to Madame Karma—Chloe ordered several scrumptious-looking cookies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There. That would help dispel the odd quivering in her belly, which she knew damn well was hunger and not, definitely not, a niggling sense of discomfort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As soon as she stepped outside with her bag, Chloe dug into the first cookie, moaning out loud when the peanut butter-chocolate treat melted in her mouth. The wind still whipped around, which she had to admit was slightly comforting, because for a few minutes, she’d almost believed Madame Karma had somehow been creating the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The air felt sticky. Close. A storm was definitely brewing. She swiped a hand over her damp forehead and began to work on her second cookie.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("There was a good turnout; many of the party goers were from the various businesses in the Fairfield complex. People milled about the flower-lined walkways, checking out the craft stalls or ")]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("enjoying the art galleries and other novelty shops. Many carried shopping bags bearing the Fairfield logo, evidence that this party wasn’t just for fun, it encouraged business.")])]), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Chloe counted many of these businesses as her customers, which pleased her. Life was good, she reminded herself. With or without a valentine—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her gaze snagged on the entrance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A man was walking into the open courtyard from the street, his sunglasses dangling in his fingers, his stride easy and loose. A man, just like any of a hundred before him, though none of the other men milling around had stopped her heart. None of them had sent her reeling, the years falling away on the light wind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("It couldn’t be.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it was. A blast from her past in the form of one tall, dark and way too gorgeous man. He was broader now, but still leanly muscled like the basketball player he’d once been. His hair was longer than she remembered, still dark as sin, curling around his collar.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ian McCall, her first kiss, her first real boyfriend.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her first everything….")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a57157f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781488078415_Chapter_1.vue
// module id = 69
// module chunks = 0